import React, { useState, useEffect } from "react";
import axios from "axios";
import { TextField, Typography } from "@material-ui/core";
import Navbar from "../../../Components/Navbar/Navbar";
import Logo from "../../../Assets/Images/Icon/logo.svg";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import PersonIcon from "@material-ui/icons/Person";
import HeadShake from "react-reveal/HeadShake";
import { getData, loginApi, errorClear } from "../../../Redux/action/action";
import Box from "@material-ui/core/Box";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector, useDispatch } from "react-redux";

import Fade from "react-reveal/Fade";
import { useHistory } from "react-router";
const Login = (props) => {
  // const counter = useSelector((state) => state);
  const [errorIs, setErrorIs] = useState(false);

  const [show, setShow] = useState(false);

  const login_api_data = useSelector((state) => state.login_Detail);

  const erro_detail = useSelector((state) => state.erro_detail);

  const { error, message } = login_api_data != undefined && login_api_data;

  const dispatch = useDispatch();
  const history = useHistory();

  // useEffect(() => {
  //   dispatch(getData());
  // }, []);

  const [state, setState] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const createHnadler = () => {
    return history.push("/signup");
  };

  const Success = () =>
    toast.success(`Login Successfuly`, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const ErrorNotification = () =>
    toast.error(`${erro_detail !== "" && erro_detail}`, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const onSubmit = async () => {
    const newdata = {
      email: state.email,
      password: state.password,
    };

    const response = await dispatch(loginApi(newdata));

    const token = localStorage.getItem("token");
    if (token) {
      history.push("/");
      Success();
    } else {
      setErrorIs(true);
      ErrorNotification();
    }
  };

  return (
    <div>
      <div style={{ backgroundColor: "whitesmoke" }} className="login-page">
        <Fade top>
          <div className="login-card">
            {props.onClick && props.onClick ? (
              <div
                style={{
                  display: "flex",
                  padding: 10,
                  justifyContent: "flex-end",
                  width: "100%",
                  fontSize: 30,
                  color: "black",
                  marginTop: "-20px",
                  cursor: "pointer",
                }}
              >
                <p onClick={props.onClick}>x</p>
              </div>
            ) : (
              ""
            )}

            {/* <Box display={{ xs: "none", sm: "none", md: "block", lg: "block" }}> */}
            <div className="toolbar_logo">
              <img style={{ width: "160px" }} src={Logo} alt="" />
            </div>
            {/* </Box> */}

            {/* <Typography variant="h6" align="center">
            Welcome to Al Tasreef
          </Typography> */}
            <Typography variant="h6" align="center">
              Sign-in to your account
            </Typography>

            <form action="">
              <TextField
                fullWidth
                name="email"
                id="outlined-basic"
                label="email"
                variant="outlined"
                type="email"
                onChange={handleChange}
              />
              <TextField
                error={error ? true : errorIs ? true : false}
                fullWidth
                name="password"
                id="outlined-basic"
                label="password"
                variant="outlined"
                type="password"
                onChange={handleChange}
                helperText={message}
              />
            </form>

            <div>
              <p style={{ color: "red" }}>
                {" "}
                {erro_detail !== "" && erro_detail}
              </p>
            </div>

            <div className="forgetPassword-div">
              <p
                style={{ fontSize: 20, Color: "black", cursor: "pointer" }}
                onClick={() => history.push("/forget_password")}
              >
                forget Password ?
              </p>
            </div>

            <button
              onClick={() => onSubmit()}
              type="button"
              class="btn btn-info"
            >
              Sign In
            </button>
            <div
              style={{
                margin: "auto",
                width: "80%",
              }}
            >
              <p
                style={{ fontSize: 20, Color: "black", cursor: "pointer" }}
                className="login-btn"
              >
                Not registered?{" "}
                <a
                  style={{ textDecoration: "underline", color: "#366883" }}
                  onClick={() => createHnadler()}
                >
                  Create an account
                </a>
              </p>
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default Login;
